import { useCallback, useEffect, useRef, useState } from "react";
import { getRequest } from "../../utils/api";
import { logout } from "../../utils/auth";
import { toast } from "react-toastify";
import moment from "moment";
import PaginationComponent from "../../Component/Pagination/pagination";

const Transactions = () => {

  const [isLoader, setIsLoader] = useState<any>(true);
  const [transList, setTransList] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);

  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);


  const getTransactionList = useCallback(async (currentPage: number) => {
    try {
      setIsLoader(true)
      const response = await getRequest(`/transaction/transactionList?page=${currentPage}&activeTab=All`);
      if (response.status === 'success') {
        setTransList(response.data as any[])
        setIsLoader(false);
        setTotalPages(response.pagination.totalPages);
        setTotalRecords(response.pagination.totalRecords);
      }
      else if (response.status == 'session_expired') {
        setIsLoader(false)
        logout()
      }
      else {
        setIsLoader(false)
        toast.error(response.message);
      }
    } catch (error) {
      setIsLoader(false)
      toast.error("Something went wrong!");
    }
  }, []);

  const isFirstRender = useRef(false); // Track first render
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = true; // Skip first render
      return;
    }
    getTransactionList(page);
  }, [page]);

  return (
    <div className="hk-pg-wrapper">
      <div className="hk-pg-body py-0">
        <div className="page-wrap">
          <div className="page-content ps-0">
            <div className="page-detail-wrap">
              <header className="page-header">
                <div>
                  <div className="page-title">
                    <h2 className="mb-0">Manage Transactions</h2>
                  </div>
                </div>
                <div className="page-options-wrap">
                  <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover no-caret d-lg-inline-block d-none"
                    href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                    data-bs-original-title="Sync Templates"><span className="btn-icon-wrap"><span
                      className="feather-icon"><i data-feather="refresh-cw"></i></span></span></a>
                  <div className="v-separator d-lg-inline-block d-none"></div>
                  {/* <button type="button" className="btn btn-dark btn-rounded">
                    <span>
                      <span className="icon"><i className="ri-add-line bticon"></i></span>
                      <span>Create New</span>
                    </span>
                  </button> */}

                  <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                    href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                    data-bs-original-title="Collapse">
                    <span className="btn-icon-wrap">
                      <span className="feather-icon"><i data-feather="chevron-up"></i></span>
                      <span className="feather-icon d-none"><i data-feather="chevron-down"></i></span>
                    </span>
                  </a>
                </div>
              </header>
              <div className="page-body">
                <div data-simplebar className="nicescroll-bar">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="table-responsive">
                            <table className="table table-hover mb-0">
                              <thead>
                                <tr>
                                  <th>Transaction ID</th>
                                  <th>User Details</th>
                                  <th>Plan Details</th>
                                  <th>Price</th>
                                  <th className="text-center">Payment Mode</th>
                                  <th className="text-center">Payment Status</th>
                                  <th className="text-center">Create Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transList && transList.length > 0 ? (
                                  transList.map((item, index) => (
                                    <tr>
                                      <td><a href="#" className="fw-bold">#{item.transaction_order_id}</a></td>
                                      <td>
                                        <div className="media align-items-center">
                                          <div className="media-head me-2">
                                            <div className="avatar avatar-xs rounded">
                                              <img src="dist/img/logo-avatar-3.png" alt="user" className="avatar-img" />
                                            </div>
                                          </div>
                                          <div className="media-body">
                                            <h6 className="fs-14 mb-0">{item.transaction_user_id?.user_first_name ?? "–"} {item.transaction_user_id?.user_last_name ?? "–"}</h6>
                                            <p className="mb-0 fs-12">{item.transaction_formdata?.email ?? "–"}</p>
                                          </div>
                                        </div>
                                      </td>
                                      <td><a href="#" className="fw-bold text-capitalize">{item.transaction_billing_cycle ?? "–"}</a></td>

                                      <td><span className="fw-bold">₹{item.transaction_amount ?? "0.00"}</span></td>

                                      <td className="text-center"><a href="#" className="fw-bold text-uppercase">{item?.method ?? "–"}</a></td>

                                      <td className="text-center"><span className={item.status == "success" ? "badge bg-success"
                                        : item.status == "panding" ? "badge bg-warning" : "badge bg-danger"
                                      }>{item.status}</span></td>

                                      <td className="text-center">{moment(item.createdAt).format('DD MMM, YYYY')}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={10}>
                                      <div className="text-center">No Record Found</div>
                                    </td>
                                  </tr>
                                )
                                }
                              </tbody>
                            </table>
                          </div>
                          <div className="card-footer d-flex justify-content-between align-items-center">

                            <div className="col-sm">
                              <div className="text-muted">Showing <span className="fw-semibold">{transList?.length || 0}</span> of <span className="fw-semibold">{totalRecords || 0}</span> Results</div>
                            </div>
                            {totalPages > 0 && <PaginationComponent totalPages={totalPages} currentPage={page} setCurrentPage={setPage} />}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Transactions